import { FeeCartItemDetails } from "features/types";
import { useAppSelector } from "hooks/useAppSelector";
import React, { useMemo, useState } from "react";
import PriceText from "./PriceText";
import { View } from "react-native";
import Dialog from "components/Dialog";
import { Text } from "@ui-kitten/components";
import { formatCurrency } from "utils/appUtils";

const FeeDetails = ({ feeItems }: { feeItems: FeeCartItemDetails[] }) => {
  const [visible, setVisible] = useState(false);
  const selectedSubscription = useAppSelector(
    (state) => state.reservationFlow.selectedSubscription
  );

  const {
    planPackage: { feeStructures },
  } = selectedSubscription!;

  // group feeItems by planPackageFeeStructureId and sum totalCreditCardCharges
  const feeItemsMap = feeItems?.reduce((acc, feeItem) => {
    const { planPackageFeeStructureId, totalPrice } = feeItem;
    if (!acc[planPackageFeeStructureId]) {
      acc[planPackageFeeStructureId] = 0;
    }
    acc[planPackageFeeStructureId] += Number(totalPrice);
    return acc;
  }, {} as { [key: number]: number });

  const findFeeById = (id: number) => {
    return feeStructures.find((fee) => fee.id === Number(id));
  };

  const getFeeNameById = (id: number) => {
    return findFeeById(id)?.name || "Fee";
  };

  const getFeeDescriptionById = (id: number) => {
    return findFeeById(id)?.description;
  };

  const getPriceTypeById = (id: number) => {
    if (!feeItems) return "CURRENCY";
    const fee = feeItems.find((fee) => fee.planPackageFeeStructureId === id);
    return fee!.priceType;
  };

  const getTotalFeesAmount = useMemo(() => {
    const totalFeesAmount = feeItems.reduce((acc, feeItem) => {
      const { totalPrice } = feeItem;
      acc += Number(totalPrice);
      return acc;
    }, 0);
    return formatCurrency(totalFeesAmount);
  }, [feeItems]);

  return (
    <View>
      <PriceText
        label="Fees & Estimated Taxes"
        text={getTotalFeesAmount}
        showInfo
        onInfoPress={() => setVisible(true)}
      />
      <Dialog visible={visible} okText="Got it!" onOk={() => setVisible(false)}>
        <View>
          <Text category="h6" style={{ marginBottom: 8 }}>
            Fees & Estimated Taxes
          </Text>
          {Object.keys(feeItemsMap)
            .map((id) => parseInt(id))
            .map((planPackageFeeStructureId) => (
              <View key={planPackageFeeStructureId} className="mt-1 mb-2 ">
                <View className="gap-2 flex-row">
                  <Text>{getFeeNameById(planPackageFeeStructureId)}:</Text>
                  <Text style={{ fontWeight: "600" }}>
                    {formatCurrency(feeItemsMap[planPackageFeeStructureId], {
                      priceType: getPriceTypeById(planPackageFeeStructureId),
                    })}
                  </Text>
                </View>
                <Text category="c1">
                  {getFeeDescriptionById(planPackageFeeStructureId)}
                </Text>
              </View>
            ))}
        </View>
      </Dialog>
    </View>
  );
};

export default FeeDetails;
